import React from 'react';
import Typography from 'housecall-ui/dist/DesignSystem/DataDisplay/Typography/Typography';
import Box from 'housecall-ui/dist/DesignSystem/Layout/Box/Box';
import WarningOutlined from 'housecall-ui/dist/IconsAndImages/Icons/WarningOutlined';

export const SomethingWentWrong = () => (
  <Box display="flex" alignItems="center" justifyContent="center" flexDirection="column">
    <WarningOutlined color="alert" size="large" backgroundCircle />
    <Typography variant="subtitle2" gutterBottom>
      Something went wrong
    </Typography>
  </Box>
);
